export const LOGIN = "LOGIN";
export const CHECK_LOGIN = "CHECK_LOGIN";
export const LOGOUT = "LOGOUT";
export const GET_DEALERS = "GET_DEALERS";
export const GET_WAVS = "GET_WAVS";
export const GET_DEALER = "GET_DEALER";
export const GET_MAKES = "GET_MAKES";
export const GET_MODELS = "GET_MODELS";
